module.exports = __webpack_public_path__ + "wasserknapp1.6fc534cc7214ff71a25d405180f8769b.png";